import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { hideBalance, setShowBalance, showBalance, toggleShowBalance } from '../store/slices/showBalanceSlice';
function useShowBalance() {
    const dispatch = useAppDispatch();
    const showBalanceState = useAppSelector(state => state.showBalance.showBalance);
    const handleToggleShowBalance = useCallback(() => {
        dispatch(toggleShowBalance());
    }, [dispatch]);
    const handleSetShowBalance = useCallback((show) => {
        dispatch(setShowBalance(show));
    }, [dispatch]);
    const handleHideBalance = useCallback(() => {
        dispatch(hideBalance());
    }, [dispatch]);
    const handleShowBalance = useCallback(() => {
        dispatch(showBalance());
    }, [dispatch]);
    return {
        showBalance: showBalanceState,
        toggleShowBalance: handleToggleShowBalance,
        setShowBalance: handleSetShowBalance,
        hideBalance: handleHideBalance,
        showBalanceAction: handleShowBalance,
    };
}
export { useShowBalance };
